define('helpers/claim',[],function() {
    'use strict';

    return {
        mapTypeTitle: [
            'Количественная',
            'Качественная',
            'Другая'
        ],
        mapStatus: [
            'icon-question-sign text-orange',
            'icon-ok-sign text-success',
            'icon-ok-sign text-success',
            'icon-remove-sign text-error'
        ],
        mapStatusTitle: [
            'Ожидание',
            'Частично подтверждена',
            'Подтверждена',
            'Отклонена'
        ],
        mapClosed: [
            '',
            'icon-lock text-warning'
        ],
        mapClosedTitle: [
            'Претензия открыта',
            'Претензия закрыта'
        ],
        mapHasDoc: [
            '',
            'icon-file text-info'
        ],
        mapHasDocTitle: [
            '',
            'Есть счета'
        ]
    };

});
